export enum UserSettingsView {
  Profile = 'Profile',
  PasswordAndSecurity = 'PasswordAndSecurity',
  General = 'General',
  TeamMembers = 'TeamMembers',
  CompanyInformation = 'CompanyInformation',
  TeamMemberPermissions = 'TeamMemberPermissions',
}
